import React from 'react';
import { Link } from 'react-router-dom';
import { useContent } from '../contexts/ContentContext';
import { getSpecialties, getSpecialtyPath } from '../utils/formationCatalog';
import { getSocialNetworks } from '../utils/socialNetworks';

const Footer = () => {
  const { getContent } = useContent();

  const companyInfo = getContent('global.company') || {};
  const contactInfo = getContent('contact.contactInfo') || [];
  const socialNetworks = getSocialNetworks(getContent);
  const specialties = getSpecialties(getContent);

  const phoneInfo = contactInfo.find((info) => info.type === 'phone');
  const emailInfo = contactInfo.find((info) => info.type === 'email');
  const locationInfo = contactInfo.find(
    (info) => info.type === 'location' || info.type === 'address'
  );
  const whatsappInfo = contactInfo.find((info) => info.type === 'whatsapp');

  const copyrightYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <h3>{companyInfo.name || 'DentoXcellence'}</h3>
            <p>{companyInfo.description || ''}</p>
            <div className="footer-social">
              {socialNetworks.map((network, index) => (
                <a
                  key={index}
                  href={network.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="social-link"
                  title={network.name}
                >
                  <i className={network.icon}></i>
                </a>
              ))}
            </div>
          </div>
          <div className="footer-section">
            <h4>Formations</h4>
            <ul className="footer-links">
              {specialties.map((specialty) => (
                <li key={specialty.id}>
                  <Link to={getSpecialtyPath(specialty.slug || specialty.id)}>
                    {specialty.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <div className="footer-contact-links-row">
            <div className="footer-section">
              <h4>Contact</h4>
              <div className="footer-contact">
                <p>
                  <i className="fas fa-map-marker-alt"></i>{' '}
                  {locationInfo?.value || companyInfo.address || ''}
                </p>
                <p>
                  <i className="fas fa-phone"></i>{' '}
                  {phoneInfo?.value || companyInfo.phone || ''}
                </p>
                <p>
                  <i className="fas fa-envelope"></i>{' '}
                  {emailInfo?.value || companyInfo.email || ''}
                </p>
                <p>
                  <i className="fas fa-clock"></i>{' '}
                  {phoneInfo?.availability || whatsappInfo?.availability || ''}
                </p>
              </div>
            </div>
            <div className="footer-section">
              <h4>Liens Rapides</h4>
              <ul className="footer-links">
                <li><Link to="/">Accueil</Link></li>
                <li><Link to="/about">À propos de nous</Link></li>
                <li><Link to="/services">Services</Link></li>
                <li><Link to="/formations">Formations</Link></li>
                <li><Link to="/experts">Experts</Link></li>
                <li><Link to="/#expert-testimonials">Témoignages</Link></li>
                <li><Link to="/temoignages#submit">Laisser un témoignage</Link></li>
                <li><Link to="/contact">Contact</Link></li>
              </ul>
            </div>
          </div>
        </div>
        <div className="footer-bottom">
          <p>
            &copy; {copyrightYear} {companyInfo.name || 'DentoXcellence'}. Tous droits réservés.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
